import {
  Backdrop,
  Box,
  Button,
  CircularProgress,
} from "@mui/material";
import React from "react";
import {
  setIsOpenWidget,
} from "../../store/slice/Addguest.slice";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import Widget from "./Widget";
import useHorecaWidget from "../../hooks/useHorecaWidget";
dayjs?.extend(customParseFormat); // Extend for custom date format parsing

let loadSettings = null;
let widgetIdSettings = null;

const HorecaWidget = ({
  floating,
}) => {
  const{
    isOpenWidget,
    send,
    handleClose,
    widgetConfig,
    theme,
    widgetLoading,
    openWidget,
    setOpenWidget,
    dispatch,
    buttonText,
    getWidgetPositionStyle,
    
  }=useHorecaWidget()

  if (widgetLoading) {
    return (
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={widgetLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (!widgetConfig?.settings?.floatButtonActive ||  floating === "relative") {
    return (
  
      send("100vh", "100%", "", "0px", "0px", "", floating),
      (
        <Widget  handleClose={()=>setOpenWidget(!openWidget)}/>
      )
    );
  }
  // Widget
  return (
    send(
      "100px",
      "150px",
      "",
      "0px",
      "0px",
      "",
      widgetConfig?.settings?.floatButtonActive
    ),
    (
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
    //      alignItems: "center",
          backgroundColor: "",
          position: "relative",
        }}
      >
        {buttonText?.trim() != "" && 
        !openWidget && (
          <Button
            sx={{
              position: "absolute",
              ...getWidgetPositionStyle(
                widgetConfig?.settings?.positionButton,
                true
              ),
              backgroundColor: theme?.widgetButton?.bgColor,
              color: theme?.widgetButton?.textColor,
              margin: "10px",
              zIndex: "99999",
            }}
            onClick={() => {
              setOpenWidget(!openWidget);
              dispatch(setIsOpenWidget(!isOpenWidget));
            }}
          >
            {buttonText}
          </Button>
        )}

        {openWidget &&
         (send("100vh", "100vw", "0px", "0px", "0px", "", floating),
          (
            <Widget  handleClose={()=>setOpenWidget(!openWidget)} />
          ))}
      </Box>
    )
  );
};
export default HorecaWidget;
